import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { addAdmin } from "../../../redux/admin/action";
import AdminForm from "./AdminForm";

const Addadmin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = (values) => {
    const payload = {
      ...values,
      status: Number(values.status),
      is_super_admin: Boolean(values.is_super_admin),
    };
    dispatch(addAdmin(payload, setSubmitting, navigate));
  };

  return (
    <AdminForm
      mode="create"
      title="Add admin"
      onSubmit={handleSubmit}
      submitting={submitting}
    />
  );
};

export default Addadmin;
